
export function recordKeys<K extends keyof any, V>(obj: Record<K, V>): K[] {
    return Object.keys(obj) as K[];
}